// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Vm-p","col":"styles_col__29MxX"};